import { AssignmentGroupType } from "@gettactic/api";

export interface AssignmentGroup {
  label: string;
  color: string;
  isAdditional?: boolean;
  shortLabel?: string;
}

export const accessAssignmentGroups: Record<
  AssignmentGroupType,
  AssignmentGroup
> = {
  Primary: {
    label: "Primary Assignment Group",
    color: "var(--color-primary)",
    shortLabel: "G1"
  },
  Secondary: {
    label: "Secondary Assignment Group",
    color: "var(--color-primary-hover)",
    isAdditional: true,
    shortLabel: "G2"
  }
};

export const accessAssignmentDefaultGroup = "Primary";
